import {numberDisplay} from 'helpers/UnitsFormatHandler';

export function rangeTextHandler(
  value: number | '' | undefined,
  min: number | undefined,
  max: number | undefined,
  inclusiveMin: boolean = false,
  inclusiveMax: boolean = false,
) {
  if (!value) {
    return undefined;
  }

  if (min !== undefined) {
    if (inclusiveMin && value <= min) {
      return `≤ ${numberDisplay(min)}`;
    }
    if (!inclusiveMin && value < min) {
      return `< ${numberDisplay(min)}`;
    }
  }

  if (max !== undefined) {
    if (inclusiveMax && value >= max) {
      return `≥ ${numberDisplay(max)}`;
    }
    if (!inclusiveMax && value > max) {
      return `> ${numberDisplay(max)}`;
    }
  }

  return undefined;
}
